import { Component, EventEmitter, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse  } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { DtoService } from '../../services/dto.service';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { FunctService } from '../../services/funct.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-bet-section-dialog',
  templateUrl: './bet-section-dialog.component.html',
  styleUrls: ['./bet-section-dialog.component.scss']
})
export class BetSectionDialogComponent implements OnInit {
  
  public selectedEvent: EventEmitter<any> = new EventEmitter();

  refLink: any;
  twodSectionList: any[] = [];

  closeTwoD: any = false;
  closeWeekend: any = false;
  closeHoliday: any = false;
  isDisabled = true;
  constructor(
    private translateService: TranslateService,
    private modalService: BsModalService,
    private http: HttpClient,
    private funct: FunctService,
    private toastr: ToastrService,
    private dto: DtoService,
    private router: Router,
    private storage: LocalStorageService,
    public modalRef: BsModalRef,
    public common: CommonService
  ) {

  }

  async ngOnInit() {

    await this.checkCloseWeekend();
    await this.checkCloseHoliday();
    await this.checkCloseSection();
    
  }

  async checkCloseWeekend() {

    const dateTime = await this.common.getDateTime();
    const currentTime = await this.common.convertMyanmarTime(dateTime);
    
    var formatter = 'EEEE';
    var day = formatDate(currentTime, formatter, 'en-US');

    var fourHour36Mins = new Date(currentTime);
    fourHour36Mins.setHours(16);
    fourHour36Mins.setMinutes(36);

    var elevenHour59Mins = new Date(currentTime);
    elevenHour59Mins.setHours(23);
    elevenHour59Mins.setMinutes(59);
   
    // note: Friday && (currentTime >= 4:36 PM) || Saturday || (Sunday && currentTime <= 4:36PM)
    if ((day == "Friday" && currentTime.getTime() >= fourHour36Mins.getTime()) ||
      (day == "Saturday") || (day == "Sunday" && currentTime.getTime() <= fourHour36Mins.getTime()) ){
      this.closeWeekend = true;
      this.closeTwoD = this.closeWeekend;
    } else {
      this.closeWeekend = false;
      this.closeTwoD = this.closeWeekend;
    }
  }

  async checkCloseHoliday() {
    if (!this.closeTwoD) {

      let holidayList = await this.getCloseHolidayList();

      const dateTime = await this.common.getDateTime();
      const currentTime = await this.common.convertMyanmarTime(dateTime);

      var fourHour36Mins = new Date(currentTime);
      fourHour36Mins.setHours(16);
      fourHour36Mins.setMinutes(36);

      var elevenHour59Mins = new Date(currentTime);
      elevenHour59Mins.setHours(23);
      elevenHour59Mins.setMinutes(59);

      if (currentTime.getTime() >= fourHour36Mins.getTime() && currentTime.getTime() <= elevenHour59Mins.getTime()) {
        
        let tomorrowDate = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate() + 1);
        
        for( var i=0; holidayList.length > i; i++ ) {
          let holidayDate = new Date(holidayList[i].date);
          
          if (
            holidayDate.getFullYear() == tomorrowDate.getFullYear() &&
            holidayDate.getMonth() == tomorrowDate.getMonth() &&
            holidayDate.getDate() == tomorrowDate.getDate() ) {

            this.closeHoliday = true;
            this.closeTwoD = this.closeHoliday;
            break;
          } else {
            this.closeHoliday = false;
            this.closeTwoD = this.closeHoliday;
            continue;
          }
        }
    
      } else {
        
        for( var i=0; holidayList.length > i; i++ ) {
          let holidayDate = new Date(holidayList[i].date);

          if(
            holidayDate.getFullYear() == currentTime.getFullYear() &&
            holidayDate.getMonth() == currentTime.getMonth() &&
            holidayDate.getDate() == currentTime.getDate() ) {

              this.closeHoliday = true;
              this.closeTwoD = this.closeHoliday;
              break;
          }
        }

      }

    }
  }

  async checkCloseSection() {

    let fourSectionList = await this.getSectionList();

    const dateTime = await this.common.getDateTime();
    const currentTime = await this.common.convertMyanmarTime(dateTime);

    for(let i=0; i < fourSectionList.length; i++){
      if (fourSectionList[i].fromTime != null && fourSectionList[i].toTime != null) {

        if (this.closeWeekend || this.closeHoliday) {
          fourSectionList[i].isClosed = true;
          fourSectionList[i].isSelected = false;
        } else {

          var toTime = fourSectionList[i].toTime.split(":");
          var to = new Date(currentTime);
          to.setHours(toTime[0]);
          to.setMinutes(toTime[1]);

          var fourHour36Mins = new Date(currentTime);
          fourHour36Mins.setHours(16);
          fourHour36Mins.setMinutes(36);
        
          if (currentTime.getTime() >= to.getTime()){      
            fourSectionList[i].isClosed = true;
            fourSectionList[i].isSelected = false;                                        
          }  
          
          if (currentTime.getTime() >= fourHour36Mins.getTime()) {  
            fourSectionList[i].isClosed = false;
            fourSectionList[i].isSelected = false;                                        
          }

        }

      }        
    }
    
    this.twodSectionList = fourSectionList;
    this.storage.store('localTwodSectionList', this.twodSectionList);

  }

  async getCloseHolidayList() {
    const axios = require('axios').default;
    const response = await axios.get(this.funct.ipaddress + 'holiday/GetHolidayList');   
    return response.data;    
  }

  async getSectionList() {
    const axios = require('axios').default;
    const response = await axios.get(this.funct.ipaddress + 'twodsection/getTwodSectionList');   
    return response.data;    
  }

  selectBetSection(id: number){
    this.isDisabled = false;
    for(let i=0; i< this.twodSectionList.length; i++){
      if(this.twodSectionList[i].id == id){
        this.twodSectionList[i].isSelected = true;
        this.storage.store('localSection', this.twodSectionList[i]);
        this.storage.store('localSectionId', this.twodSectionList[i].id);
      } 
      else{
        this.twodSectionList[i].isSelected = false;
      }
    }
  }

  twoDbet(){   
    let count=0;
    for (let i=0; i< this.twodSectionList.length; i++) {
      if (this.twodSectionList[i].isSelected) {
        this.modalRef.hide();
        if (this.refLink == 'twod-bet') { // from twod-initial
          this.router.navigate(['/twod/bet'], {state:{replaceUrl: false}});
        } else if (this.refLink == 'twod-package') { // from twod-package
          this.router.navigate(['/twod/package'], {state:{replaceUrl: false}});
        } else if (this.refLink == null) { // from twod-bet
          this.selectedEvent.emit(200);
        }
      } else {
        ++count;
      }
    }
     
    if (count == 4) {
      this.common.errorMsg("", "bet-not-select", "top");
    }
  }

  handleError(error: HttpErrorResponse){
    if (error.status == 0) {
      this.common.errorMsg("", "checkInternet", "top");
    } else if (error.status == 423) {
      this.common.errorMsg("", "youNeedLogin", "top");
      this.storage.clear('token');
      this.storage.clear('isUserLoggedIn');
    } else if (error.status == 400) {
      this.common.errorMsg("", "bad_request", "top");
    }
    return throwError(error);
  }
//For bet button
isAnySectionOpen(select): boolean {
  if(select === "s")
  {
    return true;
  }
  return false;

}

}
